import {RichText} from '@gongxigames/framework/core/fragments/display';

RichText.setStyle('LoadingScreenButton', {
    fontFamily: 'PF DinDisplay Pro',
    fontSize: 85,
    fontStyle: 'normal',
    fill: '#FFFFFF',
    align: 'center',
    verticalAlign: 'center',
    fontWeight: 'bold'
});

RichText.setStyle('LoadingScreenButtonPressed', {
    fontFamily: 'PF DinDisplay Pro',
    fontSize: 75,
    fontStyle: 'normal',
    fill: '#FFFFFF',
    align: 'center',
    verticalAlign: 'center',
    fontWeight: 'bold'
});
